// extracted by mini-css-extract-plugin
module.exports = {"container":"alert-container_container__BBBJD","hide":"alert-container_hide__qJo_D","text":"alert-container_text__GEi4p","button":"alert-container_button__DYeqU"};